+function($, document) {
	/**
	 * Constructor
	 * 
	 * @param {object} html object to attach this plugin
	 * @param {object} settings object passed into this plugin
	 * return void
	 */
	var AjaxNotification = function(element, options) {
		this.$element = $(element);
		this.$body = $(document.body);
		this.options = options;
		
		this.initialize();
	};
	
	//default settings
	AjaxNotification.DEFAULTS = {
		showOverlay: false,
		useProcessBar: false,
		defaultText: 'LOADING...'
	};
	
	/**
	 * Init this plugin
	 * 
	 * @access public
	 * @return void
	 */
	AjaxNotification.prototype.initialize = function() {
		var scope = this;
		
		$.subscribe('showajaxnotification.sn', function(event, text) {
			scope.show(text);
		});
		
		$.subscribe('hideajaxnotification.sn', function() {
			scope.hide();
		});
		
		//init the overlay
		this.initOverlay();
	};
	
	/**
	 * Show an overlay above the page as sending the ajax request
	 * 
	 * @access public
	 * @return void
	 */
	AjaxNotification.prototype.initOverlay = function() {
		if (this.options.showOverlay) {
			$('<div class="mask"></div>').appendTo($(document.body));
		}else {
			$('.mask').remove();
		}
	};
	
	/**
	 * Show ajax notification
	 * 
	 * @access public
	 * @return void
	 */
	AjaxNotification.prototype.show = function(text) {
		//use process bar to notify the ajax progress
		if (this.options.useProcessBar) {
			this.$body.addClass('sn-processing');
		//use center dialog
		}else {
			if (text) {
				this.$element.find('.loading-text').text(text);
				this.$element.css('margin-left', 0);
			}else {
				this.$element.find('.loading-text').text(this.options.defaultText);
			}
			
			this.$element.show();
		}
		
		if (this.options.showOverlay) {
			$('.mask').show();
		}
	};
	
	/**
	 * Hide ajax notification
	 * 
	 * @access public
	 * @return void
	 */
	AjaxNotification.prototype.hide = function() {
		var $this = this;
		
		//use process bar to notify the ajax progress
		if (this.options.useProcessBar) {
			setTimeout(function() {
				$this.$body.removeClass('sn-processing');
			}, 1500);
		}else {
			this.$element.hide();
		}
	};
	
	/**
	 * Work as a plugin of jquery
	 * 
	 * @access private
	 * @param {object} settings object that will be merged with default settings
	 * @return void
	 */
	function Plugin(option) {
		var $this   = $(this),
			data   	= $this.data('sn.AjaxNotification'),
			options = $.extend({}, AjaxNotification.DEFAULTS, typeof option == 'object' && option);
		  
		if ( ! data) {
			$this.data('sn.AjaxNotification', (data = new AjaxNotification(this, options)));  
		} 
		  
		if (typeof option == 'string') {
			data[option]();  
		} 
	}

	var old = $.fn.AjaxNotification;
	
	//attach this plugin into jquery prototype
	$.fn.AjaxNotification = Plugin;
	
	//fix the constructor property
	$.fn.AjaxNotification.Constructor = AjaxNotification;
	
	//clear conflict
	$.fn.AjaxNotification.noConflict = function () {
	    $.fn.AjaxNotification = old;
	    return this;
	};
}(jQuery, document);